import styled from 'styled-components';

const CrewBackgroundContainer = styled.section`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;

  .video .overlay {
    display: none;
  }
`;

export default CrewBackgroundContainer;
